export const cssPrefix = 'cn-ui-import-';
